export class NGSWorkfileResponse {
  statusMessage: string;
  isCreate: boolean;
  csvWorkfile: string;
  txtDataFile: string;

}
